import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "src/environments/environment";
import {
  UploadFileResponse,
  UploadFileStatusResponse
} from "./download-upload.types";

@Injectable({ providedIn: "root" })
export class DownloadUploadService {
  constructor(private http: HttpClient) {}

  private resolveBaseUrl(service?: "api" | "sales") {
    switch (service) {
      case "sales":
        return environment.microserviceSales;
      default:
        return environment.apiUrl;
    }
  }

  uploadFile(
    file: File,
    option: { endpoint: string; service?: "api" | "sales" }
  ) {
    const formData = new FormData();
    formData.append("file", file);
    const base = this.resolveBaseUrl(option.service);
    return this.http.post<
      string[] | UploadFileResponse[] | UploadFileStatusResponse
    >(base + option.endpoint, formData);
  }

  getFileData(endpoint: string, body?: any) {
    return this.http.post<Blob>(`${environment.apiUrl}${endpoint}`, body, {
      observe: "response",
      responseType: "blob" as "json"
    });
  }
}
